$(document).ready(function(){
   $(".rq-main-language-change .disclosure__toggle").click(function(){ 
     var getval = $(this).attr('aria-expanded');
     if(getval == 'false') {
      $('.rq-main-language-change .disclosure__toggle').attr('aria-expanded', 'true');
      $('.rq-main-language-change .disclosure-list').addClass('disclosure-list--visible');
     } else {
        $('.rq-main-language-change .disclosure__toggle').attr('aria-expanded', 'false');
        $('.rq-main-language-change .disclosure-list').removeClass('disclosure-list--visible');
     }
  });    
});  